import React from "react";
import moment from "moment";
import {
  Show,
  SimpleShowLayout,
  TextField,
  ReferenceField,
  FunctionField,
} from "react-admin";
import GoogleMapsField from "../Common/GoogleMapsField";

const LocalityMetaShow = () => {
  return (
    <Show>
      <SimpleShowLayout>
        <TextField source="id" />
        <TextField source="name" />
        <ReferenceField source="areaId" link="show" reference="Areas">
          <TextField source="name" />
        </ReferenceField>
        <ReferenceField source="cityId" link="show" reference="Cities">
          <TextField source="name" />
        </ReferenceField>
        <GoogleMapsField source="coordinates" />
        <TextField source="rentPayingCapacity" />
        <TextField label={'Trial Auto Allocation Status'} source="hasTrialAutoAllocation" />
        <TextField source="availableTrialType" />
        <TextField label={'Oms Auto Allocation Status'} source="hasOmsAutoAllocation" />
        <FunctionField label="Created At" render={(record: any) => record?.createdAt ? moment(record.createdAt).format('DD MMM YYYY') : '-'} />
        <FunctionField label="Updated At" render={(record: any) => record?.updatedAt ? moment(record.updatedAt).format('DD MMM YYYY') : '-'} />
      </SimpleShowLayout>
    </Show>
  );
};

export default LocalityMetaShow;
